<template>
  <div class="error-container" :class="{ 'has-errors': errors.length > 0 }">
    <div v-for="(error, i) in errors" class="error" :key="`error-${i}`">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["errors"],
};
</script>

<style lang="scss" scoped>
.error-container {
  display: flex;
  flex-direction: column;
  margin: 0;
  color: red;

  // &.has-errors {
  //  margin-bottom: 1em;
  // }

  .error {
    text-align: center;
    width: 100%;
  }
}
</style>